export default __webpack_public_path__ + "static/media/resilience_score_100.ccafac4d.svg";